import React from 'react';

const ArcFours = ({
  fill = 'white',
  stroke = 'rgba(240, 0, 55, 0.06)',
  strokeWidth = 1,
  className = '',
}) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="20"
        viewBox="0 0 33 20"
        fill="none"
        className={className}

      >
        <path
          d="M3.70622 1.32343C-0.013094 3.20737 -0.284001 8.37359 3.34656 10.4234C8.8993 13.5583 14.8633 16.4429 21.1864 19.0509C24.5752 20.4486 28.4473 19.7079 31.1861 17.2713C33.6553 15.0747 32.9073 11.0276 29.8688 9.72771C24.2461 7.32225 18.9601 4.66447 14.0599 1.779C10.8905 -0.0872976 6.98737 -0.33856 3.70622 1.32343Z"
          fill={fill}
          stroke={stroke}
          style={{
            mixBlendMode: 'multiply',
            filter: 'blur(1px)',
          }}
        />
        <path
          d="M3.93225 1.76973C6.95219 0.240049 10.54 0.410224 13.5201 2.04707L13.8063 2.21016C18.4187 4.92614 23.37 7.43958 28.6188 9.73164L29.6725 10.1877C32.3059 11.3146 32.9932 14.7341 31.0504 16.7111L30.8541 16.8977C28.3325 19.1409 24.8086 19.8646 21.6783 18.7063L21.3766 18.5891C15.4651 16.1508 9.87036 13.4703 4.6344 10.5705L3.59241 9.9875C0.437919 8.20636 0.532166 3.77516 3.62366 1.93867L3.93225 1.76973Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeOpacity="0.06"
        />
      </svg>
    </div>
  );
};

export default ArcFours;
